import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Mui
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import { Button, ListItemButton } from "@mui/material";

// Hooks
import { useFetchUser } from "../../../hooks/useFetchUser";

// Firebase
import { auth } from "../../../firebase/firebase";

// Icons
import { MdHome, MdPowerSettingsNew, MdMenuBook, MdHelp } from "react-icons/md";
import { HiHeart } from "react-icons/hi";
import { FaCheckCircle } from "react-icons/fa";

// Assets
import theme from "../../../assets/nav/theme.png";

type DrawerItemProps = {
    to: string;
    onClick?: any;
    Icon?: React.FC;
    primaryText: string;
    color?: string;
    subTitle?: boolean;
};

const DrawerItem: React.FC<DrawerItemProps> = ({ to, onClick, Icon, primaryText, color }) => {
    return (
        <NavLink to={to} onClick={() => onClick ?? null} className="drawer__nav__item">
            <ListItem button>
                <ListItemIcon>{Icon ? <Icon /> : null}</ListItemIcon>
                <ListItemText primary={primaryText} color={color ?? "primary"} />
            </ListItem>
        </NavLink>
    );
};

const DrawerContent = () => {
    const { t } = useTranslation();
    const { resetStates } = useFetchUser();

    // toggle theme
    const changeTheme = () => {
        const divColor = (document.getElementById("color") as any).classList;
        if (divColor.contains("normal")) {
            divColor.replace("normal", "inverse");
            localStorage.setItem("theme", "inverse");
        } else {
            divColor.replace("inverse", "normal");
            localStorage.setItem("theme", "normal");
        }
    };

    return (
        <div className="portal">
            <div className="drawer__nav">
                <List>
                    {/* <DrawerItem to="/formtest" Icon={MdMonetizationOn} primaryText={t("formtest")} /> */}
                    {/* {currentParticipant?.hasLibraryAccess && <DrawerItem to="/library" Icon={MdOutlineVideoLibrary} primaryText={t("library")} />} */}
                    <DrawerItem to="/home" Icon={MdHome} primaryText={t("home")} />
                    <DrawerItem to="/favouritesTopics" Icon={HiHeart} primaryText={t("favourites")} />
                    <DrawerItem to="/completedTopics" Icon={FaCheckCircle} primaryText={t("completed")} />
                    <DrawerItem to="/notebook" Icon={MdMenuBook} primaryText={t("notebook")} />
                    <DrawerItem to="/help" Icon={MdHelp} primaryText={t("help")} />
                </List>
                <Divider />
                <List>
                    <div
                        className="drawer__nav__item"
                        onClick={() => {
                            resetStates();
                            auth.signOut();
                        }}
                    >
                        <ListItemButton>
                            <ListItemIcon>
                                <MdPowerSettingsNew />
                            </ListItemIcon>
                            <ListItemText primary={t("logout")} color="primary" />
                        </ListItemButton>
                    </div>
                </List>
                <div className="nav__content__theme nav__theme__drawer" style={{ marginLeft: "6px" }}>
                    <Button onClick={changeTheme} size="medium">
                        <img src={theme} alt="" />
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default DrawerContent;
